import { render, staticRenderFns } from "./AdoptionView.vue?vue&type=template&id=81fdb2f4&scoped=true"
import script from "./AdoptionView.vue?vue&type=script&lang=js"
export * from "./AdoptionView.vue?vue&type=script&lang=js"
import style0 from "./AdoptionView.vue?vue&type=style&index=0&id=81fdb2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fdb2f4",
  null
  
)

export default component.exports